import Scene from "~/scene";
import { getItem, removeItem } from "~/util/cookies";
import { node } from "./util/dom";

const WASM_COOKIE_NAME = "enableWASM";

export function wasmInfo() {
	if (getItem(WASM_COOKIE_NAME) === "1" && !Scene.isWasmActive()) {
		const container = node("div", { className: "wasm-info" });
		const dialog = node("div", { className: "wasm-info-dialog" });
		const desc = node("p", { className: "wasm-info-dialog__desc" });
		const btns = node("div", { className: "wasm-info-dialog__buttons" });
		const btnRemoveReload = node("button", { className: "wasm-info-dialog__clearBtn wasm-info-dialog__btn" });
		const btnClose = node("button", { className: "wasm-info-dialog__closeBtn wasm-info-dialog__btn" });

		btnRemoveReload.addEventListener("click", () => {
			removeItem(WASM_COOKIE_NAME);
			location.reload();
		});
		btnClose.addEventListener("click", () => {
			container.remove();
		});
		btns.append(btnRemoveReload, btnClose);
		btnRemoveReload.textContent = `Smazat a znovu načíst stránku`;
		btnClose.textContent = `Zavřít dialog`;
		desc.innerHTML = `Je zapnutá WASM cookie na mapě/3D, díky tomu je omezená funkčnost stránek a můžou se vyskytnout problémy s načítáním obsahu (hlavně iframe).<br />Nechcete cookie smazat?`;
		dialog.append(desc, btns);
		container.append(dialog);
		document.body.append(container);
	}
}
